"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var qs = require("qs");
var URLQueryParams = /** @class */ (function () {
    function URLQueryParams() {
    }
    URLQueryParams.parse = function (search) {
        return qs.parse(search, { ignoreQueryPrefix: true });
    };
    URLQueryParams.stringify = function (json) {
        return qs.stringify(json, { encode: true });
    };
    return URLQueryParams;
}());
exports.default = URLQueryParams;
